import external from '../../tools/base.external';

export default class ApiOrganisation extends external {
    async getOrganisation(data) {
        let organisation = await this.post.json(`organisations/search/email`, data);

        return organisation;
    }
    
    async updateOrganisation(id, data, token) {
        let organisation = await this.put.json(`organisations/${id}`, data, token);
        
        return organisation;
    }
}